module.exports = "/virtual-football-league/img/amblems/right/Italy/Fake_Lazio.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Italy/Fake_Lazio.png
// module id = 2145
// module chunks = 4